import React from 'react';
import { cn } from '@/lib/utils';

export function MMLogo({ className, alt = 'Measure Marketer', ...props }) {
  return (
    <img
      src="/logo.png"
      alt={alt}
      className={cn('h-7 w-auto select-none', className)}
      onError={(e) => { e.currentTarget.style.display = 'none'; }}
      draggable={false}
      {...props}
    />
  );
}

export function MMLogoMark({ className, size = 28, ...props }) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('shrink-0', className)}
      aria-label="Measure Marketer"
      role="img"
      {...props}
    >
      <path d="M 9 16 L 22 26 L 35 26 L 48 10" stroke="#BBD3E3" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" opacity="0.55" />
      <rect x="4" y="22" width="10" height="38" rx="5" fill="#7D2E48" />
      <rect x="17" y="26" width="10" height="34" rx="5" fill="#243651" />
      <rect x="30" y="26" width="10" height="34" rx="5" fill="#5A7493" />
      <rect x="43" y="14" width="10" height="46" rx="5" fill="#1FA679" />
      <circle cx="9" cy="16" r="5.5" fill="#F25E7C" />
      <circle cx="22" cy="26" r="5.5" fill="#A0BAD4" />
      <circle cx="35" cy="26" r="5.5" fill="#8AA8C5" />
      <circle cx="48" cy="10" r="5.5" fill="#2BC97D" />
    </svg>
  );
}
